var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"tile"},[_c('wx-skeleton-loader',{staticClass:"tile",attrs:{"type":"image"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }